module.exports = __webpack_public_path__ + "assets/certificate_pdf/Designing 3D Animation Games Using Maya_Silicon Stone Education_20170222.10c67fa1.pdf";